import React from 'react';
import { AuthContext } from '../context';
import { useCognitoAuth } from './useCognitoAuth';
import { AuthProvider } from 'react-oidc-context';
import { cognitoAuthConfig } from './cogitoAuthConfig';

interface CognitoAuthProviderProperties {
  children: React.ReactNode;
}

const InternalCognitoAuthProvider: React.FC<CognitoAuthProviderProperties> = ({ children }) => {
  const authService = useCognitoAuth();
  return <AuthContext.Provider value={authService}>{children}</AuthContext.Provider>;
};

export const CognitoAuthProvider: React.FC<CognitoAuthProviderProperties> = ({ children }) => {
  return (
    <AuthProvider {...cognitoAuthConfig}>
      <InternalCognitoAuthProvider>{children}</InternalCognitoAuthProvider>
    </AuthProvider>
  );
};
